import React, { useState } from 'react'
import style from './PrintingSystems.module.css'
import { useTranslation } from 'react-i18next'
import ContactsPopup from '../../../Components/PopUp/ContactPopUp'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'

const PrintingSystems = () => {
  const { t } = useTranslation()
  const [showPopup, setShowPopup] = useState(false)

  const handleOpenPopup = () => setShowPopup(true)
  const handleClosePopup = () => setShowPopup(false)

  const titleText = t('printingSystems.title')

  return (
    <div className={style.engineering} id="engineering">
      <div className={`customContainer ${style.engineering_wrap}`}>
        <h2 className={style.title}>{titleText}</h2>
        <button onClick={handleOpenPopup} className={style.button}>
          {t('printingSystems.button')}
        </button>
      </div>
      <ContactsPopup
        show={showPopup}
        onHide={handleClosePopup}
        title={titleText}
      />
      <div className={style.block_arrow}>
        <ScrollArrow />
      </div>
    </div>
  )
}

export default PrintingSystems
